import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
const t = (key, params) => app.translator.trans('ernestdefoe-parley-calls.forum.' + key, params);

/**
 * The alert shown when a mic or camera will not start, with the way to find
 * out why attached to it.
 *
 * Every one of these used to be a dead end: a member was told the microphone
 * could not be used and left to go and find their operating system's sound
 * settings on their own. Putting the check on the alert means the answer is
 * one click from the moment the question arises, which is the only moment
 * anybody is going to look for it.
 */
export default function deviceAlert(key) {
  app.alerts.show({
    type: 'error',
    controls: [m(Button, {
      className: "Button Button--link",
      onclick: () => app.parleyCalls.checkDevices()
    }, t('check.open'))]
  }, t(key));
}